import { ANNOTATE_DRAW_TOOL_IDS, POINTER_ICONS, TABS_IDS } from '../utils/constants';

export const SELECT_TOOL = 'SELECT_TOOL';

const getAnnotatePointerForTool = (tabId, toolId) => {
  if (tabId !== TABS_IDS.ANNOTATE) {
    return null;
  }
  return toolId && ANNOTATE_DRAW_TOOL_IDS.includes(toolId)
    ? POINTER_ICONS.DRAW
    : POINTER_ICONS.DEFAULT;
};

const selectTool = (state, payload) => {
  const nextToolId = payload.toolId ?? null;
  if (state.toolId === nextToolId) {
    return state;
  }

  const nextPointer = getAnnotatePointerForTool(state.tabId, nextToolId);

  return {
    ...state,
    toolId: nextToolId,
    selectionsIds: payload.keepSelections ? state.selectionsIds : [],
    ...(nextPointer != null ? { pointerCssIcon: nextPointer } : {}),
  };
};

export default selectTool;
